import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';
import { intlReducer } from 'react-intl-redux';
import mixpanel from 'mixpanel-browser';

import { IDENTITY_LOGOUT_OK, IDENTITY_SELECT_ROLE } from './types';

import addresses from './addresses';
import admin from './admin';
import approvals from './approvals';
import backgroundCheck from './backgroundCheck';
import clients from './clients';
import dialogs from './dialogs';
import documents from './documents';
import formInstances from './formInstances';
import identity from './identity';
import invites from './invites';
import jobs from './jobs';
import loader from './loader';
import notifications from './notifications';
import onboarding from './onboarding';
import positions from './positions';
import projects from './projects';
import signatures from './signatures';
import tenants from './tenants';
import timekeeping from './timekeeping';
import users from './users';
import wizard from './wizard';
import banking from './banking';
import infrastructure from './infrastructure';
import i9s from './i9s';
import invoices from './invoices';
import payrolls from './payrolls';

const appReducer = combineReducers({
    routing: routerReducer,
    form: formReducer,
    intl: intlReducer,

    addresses: addresses,
    admin: admin,
    approvals: approvals,
    backgroundCheck: backgroundCheck,
    banking: banking,
    clients: clients,
    dialogs: dialogs,
    documents: documents,
    formInstances: formInstances,
    i9s: i9s,
    identity: identity,
    infrastructure: infrastructure,
    invites: invites,
    jobs: jobs,
    loader: loader,
    notifications: notifications,
    onboarding: onboarding,
    positions: positions,
    projects: projects,
    signatures: signatures,
    tenants: tenants,
    timekeeping: timekeeping,
    users: users,
    invoices: invoices,
    payrolls: payrolls,

    wizard: wizard
});

const defaultData = {
    addresses: {},
    admin: {},
    approvals: {},
    backgroundCheck: { current: {}, list: [] },
    banking: {},
    clients: {},
    dialogs: {},
    documents: {},
    formInstances: {},
    jobs: {},
    infrastructure: { menuVisible: false },
    invites: {},
    notifications: {},
    positions: {},
    projects: {},
    onboarding: { progression: {} },
    signatures: {},
    tenants: {},
    timekeeping: { timesheets: {}, timesheetShifts: {} },
    users: {},
    wizard: {},
    invoices: {}
};

const rootReducer = (state, action) => {
    switch (action.type) {
        case IDENTITY_LOGOUT_OK:
            return { ...state, ...defaultData, identity: { isAuthenticated: false } };

        case IDENTITY_SELECT_ROLE:
            const role = action.data;
            const roleString = `${role.role}/${role.resource}/${role.resource_id}`;
            mixpanel.people.set({ role: roleString });
            return {
                ...state,
                ...defaultData,
                identity: { ...state.identity, role },
                tenants: { ...state.tenants }
            };

        default:
            return appReducer(state, action);
    }
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.jsx